var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"overlay-shadow",class:{ active: _vm.isMenuMobileVisible || _vm.isModalEmailVisible || _vm.isModalUserVisible || _vm.isMenuUploadVisible || _vm.active },on:{"click":_vm.hideMenuMobile}})}
var staticRenderFns = []

export { render, staticRenderFns }